// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"072994a1","455":"37d4b3e6","977":"24783e13"}[chunkId] + ".chunk.js";
};